let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dCr3f")).then(() => parcelRequire('cPKSv'));